import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import $ from "jquery";
import { HttpService } from "../../service/HTTPService/HttpService";
import { BindingURLService } from "../../service/Bindingurlservice/binding-url.service";
import { DomSanitizer } from "@angular/platform-browser";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Globals } from "../../globals";
import * as CryptoJS from "crypto-js";
import Swal from "sweetalert2";
import { ApiService } from "../../service/apiUrls/apiUrl.service";
import { MatSidenav } from "@angular/material/sidenav";
import { Subscription } from "rxjs";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ShareddataService } from "../../service/sharedDataService/shareddata.service";
import { MsalService } from "@azure/msal-angular";

@Component({
  selector: "app-dashboard",
  templateUrl: "./default-layout.component.html",
  styleUrls: ["./default-layout.component.scss"],
})
export class DefaultLayoutComponent implements OnInit, AfterViewInit {
  private routerSubscription!: Subscription;
  @ViewChild("sidenav") sidenav: MatSidenav;
  disablebutton: boolean = true;
  showSubmenu: boolean = false;
  linkNu;
  public barVisible1 = false;
  public barVisible2 = false;
  public barVisible3 = false;
  public barVisible4 = false;
  public barVisible5 = false;
  public sidebarMinimized = false;
  changes: MutationObserver;
  public element: HTMLElement = document.body;
  public username: string;
  links: Array<{ text: string; path: string }>;
  alarmMenuDisplay = false;
  dashboardDisplay = false;
  manageMenuDisplay = false;
  reportChartsMenuDisplay = false;
  repchartsMenuDisplay = false;
  breadcrumList: any[] = [];
  selectedVerifyPass;
  arr_AlertMsg: any[] = [];
  PresentYearVal;
  passVal;
  targetVal;
  imagePath: any;
  imagepath2: any;
  navJSON: any = [];
  originalNavJSON;
  userType;
  threeTechName;
  selectedConfirmPassword: any;
  Currentpassword: any;
  hiddenNav: boolean = true;
  getJsonData;
  emptyChildData = [];
  childemptyurl;
  loginToken;
  menuVisible: boolean = false;
  activeMenuId: string | null = null;
  activeSubMenuId: string | null = null;
  isMobile: boolean = false;
  menuItem;
  token = "";
  currentCustomerTime;
  @Output() sendData: EventEmitter<string> = new EventEmitter();
  public link = "";
  version;
  accCode;
  accTimeZone;
  notificationMessage;
  showNotifcationMsg;
  notificationColor;
  prodMode;
  supportNavJson;

  private clickListener: () => void;
  constructor(
    private httpC: HttpClient,
    private http: HttpService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private modalService: NgbModal,
    private globals: Globals,
    private urlAuthentication: BindingURLService,
    private apiUrl: ApiService,
    private authService: MsalService,
    private sharedDataService: ShareddataService,
    private readonly route: ActivatedRoute,
  ) {
    this.loginToken = sessionStorage.getItem("invUIToken");
    this.version = this.urlAuthentication?.version || "Version not found";
    this.prodMode = this.urlAuthentication?.devMode;
    setTimeout(() => {
      $(".menuId").removeAttr("href");
    }, 1000);

    this.accCode = sessionStorage.getItem("accCode");
    this.accTimeZone = sessionStorage.getItem("custTimeZone");
    this.accTimeZone = this.accTimeZone ? this.accTimeZone : 0;
    this.width = window.innerWidth;

    this.http.get("assets/JSON/message.json").subscribe((res) => {
      const getResp: string = JSON.stringify(res);
      const msgInfo = JSON.parse(getResp);
      this.notificationMessage = msgInfo.message;
      this.showNotifcationMsg = msgInfo.showMessage;
      this.notificationColor = msgInfo.color;
    });
    this.username = sessionStorage.getItem("user");
    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        let currentUrl: string = event.urlAfterRedirects;

        let presentDate = new Date();
        this.PresentYearVal = presentDate.getFullYear();
        this.breadcrumList = [];
        if (currentUrl.includes("userSetting")) {
          this.isVisible(2);
          this.breadcrumList.push({
            href: "#",
            name: "User Settings",
            class: "breadcrumb-item active",
          });
        }

        if (currentUrl.includes("106")) {
          this.isVisible(2);
          this.breadcrumList.push({
            href: "#",
            name: "Alarms",
            class: "breadcrumb-item active",
          });
        } else if (currentUrl.includes("RP0101")) {
          this.isVisible(5);
          this.breadcrumList.push(
            {
              href: "#",
              name: "Reports & Charts ",
              class: "breadcrumb-item",
            },
            {
              href: "#",
              name: "Analytical Reports",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("101")) {
          this.isVisible(1);
          this.breadcrumList.push(
            { href: "#", name: "Dashboard", class: "breadcrumb-item active" },
            {
              href: "#",
              name: "Alarm Dashboard",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("115")) {
          this.isVisible(1);
          this.breadcrumList.push(
            { href: "#", name: "Commands", class: "breadcrumb-item" },
            {
              href: "#",
              name: "Modbus Terminal",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("modbusTerminalHistory")) {
          this.isVisible(1);
          this.breadcrumList.push(
            { href: "#", name: "Commands", class: "breadcrumb-item" },
            {
              href: "#",
              name: "Modbus Terminal History",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("104")) {
          this.isVisible(3);
          this.breadcrumList.push(
            { href: "#", name: "Manage", class: "breadcrumb-item" },
            {
              href: "#",
              name: "Site Listing",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("RP0105")) {
          this.isVisible(4);
          this.breadcrumList.push(
            {
              href: "#",
              name: "Reports & Charts ",
              class: "breadcrumb-item",
            },
            {
              href: "#",
              name: "RMS Health Report",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("105")) {
          this.isVisible(3);
          this.breadcrumList.push(
            { href: "#", name: "Manage", class: "breadcrumb-item" },
            {
              href: "#",
              name: "Site Monitoring Dashboard",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("siteMaps")) {
          this.isVisible(4);
          this.breadcrumList.push({
            href: "#",
            name: "Sites on Map",
            class: "breadcrumb-item",
          });
        } else if (currentUrl.includes("chartsReports")) {
          this.isVisible(4);
          this.breadcrumList.push({
            href: "#",
            name: "Reports & Charts ",
            class: "breadcrumb-item",
          });
        } else if (currentUrl.includes("RP0103")) {
          this.isVisible(4);
          this.breadcrumList.push(
            {
              href: "#",
              name: "Reports & Charts ",
              class: "breadcrumb-item",
            },
            {
              href: "#",
              name: "Energy Reports",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("tenantDashboard")) {
          this.isVisible(5);
          this.breadcrumList.push(
            {
              href: "#",
              name: "Manage ",
              class: "breadcrumb-item",
            },
            {
              href: "#",
              name: "Site Tenants",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("siteDetails")) {
          let previous: any = sessionStorage.getItem("previousUrl");
          if (previous == 2) {
            this.breadcrumList.push(
              { href: "#/106", name: "Alarms", class: "breadcrumb-item" },
              {
                href: "#",
                name: "Site Details",
                class: "breadcrumb-item active",
              },
            );
          } else if (previous == 3) {
            this.breadcrumList.push(
              { href: "#", name: "Manage", class: "breadcrumb-item" },
              {
                href: "#/104",
                name: "Site Listing",
                class: "breadcrumb-item",
              },
              {
                href: "#",
                name: "Site Details",
                class: "breadcrumb-item active",
              },
            );
          } else if (previous == 4) {
            this.breadcrumList.push(
              {
                href: "#/112",
                name: "Sites on Map",
                class: "breadcrumb-item",
              },
              {
                href: "#",
                name: "Site Details",
                class: "breadcrumb-item active",
              },
            );
          } else if (previous == 5) {
            this.breadcrumList.push(
              {
                href: "#",
                name: "Commands",
                class: "breadcrumb-item active",
              },
              {
                href: "#/117",
                name: "Equipment Command",
                class: "breadcrumb-item active",
              },
              {
                href: "#",
                name: "Site Details",
                class: "breadcrumb-item active",
              },
            );
          }
        } else if (currentUrl.includes("energydash")) {
          this.breadcrumList.push(
            { href: "#", name: "Manage", class: "breadcrumb-item" },
            { href: "#/104", name: "Site Listing", class: "breadcrumb-item" },
            {
              href: "#",
              name: "Site Details",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("alarmHistory")) {
          this.breadcrumList.push(
            { href: "#/106", name: "Alarms", class: "breadcrumb-item" },
            {
              href: "#",
              name: "Alarm History",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("110")) {
          this.breadcrumList.push(
            {
              href: "#",
              name: "Reports & Charts",
              class: "breadcrumb-item active",
            },
            {
              href: "#",
              name: "Custom Report",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("NewCustomReportsModule")) {
          this.breadcrumList.push(
            {
              href: "#",
              name: "Reports & Charts",
              class: "breadcrumb-item active",
            },
            {
              href: "#",
              name: "Custom Report",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("RP0102")) {
          this.breadcrumList.push(
            {
              href: "#",
              name: "Reports & Charts",
              class: "breadcrumb-item active",
            },
            {
              href: "#",
              name: "Controller Report",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("117")) {
          this.isVisible(5);
          this.breadcrumList.push(
            { href: "#", name: "Commands", class: "breadcrumb-item active" },
            {
              href: "#",
              name: "Equipment Command",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("541")) {
          this.breadcrumList.push(
            { href: "#", name: "Commands", class: "breadcrumb-item" },
            {
              href: "#",
              name: "Outgoing Command",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("equipments")) {
          this.isVisible(sessionStorage.getItem("previousUrl"));
          if (this.barVisible3) {
            this.breadcrumList.push(
              { href: "#", name: "Manage", class: "breadcrumb-item" },
              {
                href: "#/104",
                name: "Site Listing",
                class: "breadcrumb-item",
              },
              { href: "#", name: "Site Details", class: "breadcrumb-item" },
              { href: "#", name: "Asset", class: "breadcrumb-item active" },
            );
          } else if (this.barVisible2) {
            this.breadcrumList.push(
              { href: "#/106", name: "Alarms", class: "breadcrumb-item" },
              { href: "#", name: "Site Details", class: "breadcrumb-item" },
              { href: "#", name: "Asset", class: "breadcrumb-item active" },
            );
          } else if (this.barVisible4) {
            this.breadcrumList.push(
              {
                href: "#/112",
                name: "Sites on Map",
                class: "breadcrumb-item",
              },
              { href: "#", name: "Site Details", class: "breadcrumb-item" },
              { href: "#", name: "Asset", class: "breadcrumb-item active" },
            );
          } else if (this.barVisible5) {
            this.breadcrumList.push(
              { href: "#", name: "Commands", class: "breadcrumb-item" },
              {
                href: "#/117",
                name: "Equipment Command",
                class: "breadcrumb-item",
              },
              { href: "#", name: "Site Details", class: "breadcrumb-item" },
              { href: "#", name: "Asset", class: "breadcrumb-item active" },
            );
          }
        } else if (currentUrl.includes("getControllerMdl")) {
          this.isVisible(3);
          if (this.barVisible2) {
            this.breadcrumList.push(
              { href: "#", name: "Manage", class: "breadcrumb-item" },
              {
                href: "#/104",
                name: "Site Listing",
                class: "breadcrumb-item",
              },
              { href: "#", name: "Site Details", class: "breadcrumb-item" },
              { href: "#", name: "Asset", class: "breadcrumb-item active" },
            );
          } else if (this.barVisible3) {
            this.breadcrumList.push(
              { href: "#", name: "Manage", class: "breadcrumb-item" },
              {
                href: "#/104",
                name: "Site Listing",
                class: "breadcrumb-item",
              },
              { href: "#", name: "Site Details", class: "breadcrumb-item" },
              { href: "#", name: "Asset", class: "breadcrumb-item" },
            );
          }
        } else if (currentUrl.includes("isenseConfig")) {
          let previous: any = sessionStorage.getItem("previousUrl");
          if (previous == 2) {
            this.breadcrumList.push(
              { href: "#/106", name: "alarms", class: "breadcrumb-item" },
              { href: "#", name: "Site Details", class: "breadcrumb-item" },
              {
                href: "#",
                name: "iSense Config",
                class: "breadcrumb-item active",
              },
            );
          } else if (previous == 3) {
            this.breadcrumList.push(
              { href: "#", name: "Manage", class: "breadcrumb-item" },
              {
                href: "#/104",
                name: "Site Listing",
                class: "breadcrumb-item",
              },
              { href: "#", name: "Site Details", class: "breadcrumb-item" },
              {
                href: "#",
                name: "iSense Config",
                class: "breadcrumb-item active",
              },
            );
          } else if (previous == 4) {
            this.breadcrumList.push(
              {
                href: "#/112",
                name: "Sites on Map",
                class: "breadcrumb-item",
              },
              { href: "#", name: "Site Details", class: "breadcrumb-item" },
              {
                href: "#",
                name: "iSense Config",
                class: "breadcrumb-item active",
              },
            );
          } else if (previous == 5) {
            this.breadcrumList.push(
              { href: "#", name: "Manage", class: "breadcrumb-item" },
              {
                href: "#/117",
                name: "Equipment Command",
                class: "breadcrumb-item",
              },
              { href: "#", name: "Site Details", class: "breadcrumb-item" },
              {
                href: "#",
                name: "iSense Config",
                class: "breadcrumb-item active",
              },
            );
          }
        } else if (currentUrl.includes("newgraphicaldashboard")) {
          let previous: any = sessionStorage.getItem("previousUrl");
          if (previous == 2) {
            this.breadcrumList.push(
              { href: "#", name: "Site Details", class: "breadcrumb-item" },
              {
                href: "#",
                name: "Graphical Dashboard",
                class: "breadcrumb-item active",
              },
            );
          } else if (previous == 3) {
            this.breadcrumList.push(
              { href: "#", name: "Manage", class: "breadcrumb-item" },
              {
                href: "#/104",
                name: "Site Listing",
                class: "breadcrumb-item",
              },
              { href: "#", name: "Site Details", class: "breadcrumb-item" },
              {
                href: "#",
                name: "Graphical Dashboard",
                class: "breadcrumb-item active",
              },
            );
          } else if (previous == 4) {
            this.breadcrumList.push(
              {
                href: "#/112",
                name: "Sites on Map",
                class: "breadcrumb-item",
              },
              { href: "#", name: "Site Details", class: "breadcrumb-item" },
              {
                href: "#",
                name: "Site Layout",
                class: "breadcrumb-item active",
              },
            );
          } else if (previous == 5) {
            this.breadcrumList.push(
              { href: "#", name: "Manage", class: "breadcrumb-item" },
              {
                href: "#/117",
                name: "Equipment Command",
                class: "breadcrumb-item",
              },
              { href: "#", name: "Site Details", class: "breadcrumb-item" },
              {
                href: "#",
                name: "Site Layout",
                class: "breadcrumb-item active",
              },
            );
          }
        } else if (currentUrl.includes("graphicalDashboard")) {
          let previous: any = sessionStorage.getItem("previousUrl");
          if (previous == 2) {
            this.breadcrumList.push(
              { href: "#/106", name: "Alarms", class: "breadcrumb-item" },
              { href: "#", name: "Site Details", class: "breadcrumb-item" },
              {
                href: "#",
                name: "Graphical Dashboard",
                class: "breadcrumb-item active",
              },
            );
          } else if (previous == 3) {
            this.breadcrumList.push(
              { href: "#", name: "Manage", class: "breadcrumb-item" },
              {
                href: "#/104",
                name: "Site Listing",
                class: "breadcrumb-item",
              },
              { href: "#", name: "Site Details", class: "breadcrumb-item" },
              {
                href: "#",
                name: "Graphical Dashboard",
                class: "breadcrumb-item active",
              },
            );
          } else if (previous == 4) {
            this.breadcrumList.push(
              {
                href: "#/112",
                name: "Sites on Map",
                class: "breadcrumb-item",
              },
              { href: "#", name: "Site Details", class: "breadcrumb-item" },
              {
                href: "#",
                name: "Graphical Dashboard",
                class: "breadcrumb-item active",
              },
            );
          } else if (previous == 5) {
            this.breadcrumList.push(
              { href: "#", name: "Manage", class: "breadcrumb-item" },
              {
                href: "#/117",
                name: "Equipment Command",
                class: "breadcrumb-item",
              },
              { href: "#", name: "Site Details", class: "breadcrumb-item" },
              {
                href: "#",
                name: "Site Layout",
                class: "breadcrumb-item active",
              },
            );
          }
        } else if (currentUrl.includes("102")) {
          this.isVisible(3);
          this.breadcrumList.push(
            { href: "#", name: "Dashboard", class: "breadcrumb-item active" },
            {
              href: "#",
              name: "High Level Summary Dashboard",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("116")) {
          this.isVisible(3);
          this.breadcrumList.push({
            href: "#",
            name: "Alarm Legends",
            class: "breadcrumb-item active",
          });
        } else if (currentUrl.includes("112")) {
          this.isVisible(3);
          this.breadcrumList.push({
            href: "#",
            name: "Sites On Map",
            class: "breadcrumb-item active",
          });
        } else if (currentUrl.includes("121")) {
          this.isVisible(3);
          this.breadcrumList.push(
            { href: "#", name: "Manage", class: "breadcrumb-item" },
            {
              href: "#",
              name: "Dashboard",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("141")) {
          this.isVisible(3);
          this.breadcrumList.push(
            { href: "#", name: "Manage", class: "breadcrumb-item" },
            {
              href: "#",
              name: "Dashboard",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("211")) {
          this.isVisible(3);
          this.breadcrumList.push(
            { href: "#", name: "Manage", class: "breadcrumb-item" },
            {
              href: "#",
              name: "Three Phase Dashboard",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("212")) {
          this.isVisible(3);
          this.breadcrumList.push(
            { href: "#", name: "Manage", class: "breadcrumb-item" },
            {
              href: "#",
              name: "Single Phase Dashboard",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("124")) {
          this.isVisible(3);
          this.breadcrumList.push({
            href: "#",
            name: "Payment History",
            class: "breadcrumb-item active",
          });
        } else if (currentUrl.includes("123")) {
          this.isVisible(3);

          this.breadcrumList.push(
            { href: "#", name: "View", class: "breadcrumb-item" },
            {
              href: "#",
              name: "Calender View",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("125")) {
          this.isVisible(3);

          this.breadcrumList.push(
            { href: "#", name: "Manage", class: "breadcrumb-item" },
            {
              href: "#",
              name: "Multiple Charts",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("122")) {
          this.isVisible(3);
          this.breadcrumList.push(
            { href: "#", name: "Manage", class: "breadcrumb-item" },
            {
              href: "#",
              name: "Site Monitoring Dashboard",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("140")) {
          this.isVisible(3);
          this.breadcrumList.push(
            { href: "#", name: "Manage", class: "breadcrumb-item" },
            {
              href: "#",
              name: "Site Monitoring Dashboard",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("130")) {
          this.isVisible(3);
          this.breadcrumList.push(
            { href: "#", name: "Manage", class: "breadcrumb-item" },
            {
              href: "#",
              name: "Consumption V/S Cost",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("vending")) {
          this.isVisible(3);
          this.breadcrumList.push({
            href: "#",
            name: "Vending",
            class: "breadcrumb-item active",
          });
        } else if (currentUrl.includes("136")) {
          this.isVisible(3);
          this.breadcrumList.push({
            href: "#",
            name: "Support",
            class: "breadcrumb-item active",
          });
        } else if (currentUrl.includes("137")) {
          this.isVisible(3);
          this.breadcrumList.push(
            { href: "#", name: "Manage", class: "breadcrumb-item" },
            {
              href: "#",
              name: "Dashboard (Time Diff)",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("EnergyConsumAnalytics")) {
          this.isVisible(3);
          this.breadcrumList.push(
            { href: "#", name: "Analytics", class: "breadcrumb-item" },
            {
              href: "#",
              name: "Energy Consumption Analytics",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("139")) {
          this.isVisible(3);
          this.breadcrumList.push(
            { href: "#", name: "Manage", class: "breadcrumb-item" },
            {
              href: "#",
              name: "Command Audit Log",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("127")) {
          this.isVisible(3);
          this.breadcrumList.push(
            { href: "#", name: "View", class: "breadcrumb-item" },
            {
              href: "#",
              name: "LCD View",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("126")) {
          this.isVisible(3);
          this.breadcrumList.push(
            { href: "#", name: "View", class: "breadcrumb-item" },
            {
              href: "#",
              name: "Tag View",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("129")) {
          this.isVisible(3);
          this.breadcrumList.push({
            href: "#",
            name: "High Level Dashboard",
            class: "breadcrumb-item active",
          });
        } else if (currentUrl.includes("131")) {
          this.isVisible(3);
          this.breadcrumList.push(
            { href: "#", name: "Manage", class: "breadcrumb-item" },
            {
              href: "#",
              name: "LIB Dashboard",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("154")) {
          this.isVisible(3);
          this.breadcrumList.push(
            { href: "#", name: "Analytics & Charts", class: "breadcrumb-item" },
            {
              href: "#",
              name: "Charts",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("OptimizedCharts")) {
          this.isVisible(3);
          this.breadcrumList.push(
            { href: "#", name: "Reports", class: "breadcrumb-item" },
            {
              href: "#",
              name: "Charts",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("multiple charts")) {
          this.isVisible(3);
          this.breadcrumList.push(
            { href: "#", name: "Reports", class: "breadcrumb-item" },
            {
              href: "#",
              name: "Charts",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("multiple charts")) {
          this.isVisible(3);
          this.breadcrumList.push(
            { href: "#", name: "Reports", class: "breadcrumb-item" },
            {
              href: "#",
              name: "Charts",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("156")) {
          this.isVisible(3);
          this.breadcrumList.push(
            {
              href: "#",
              name: "Analytics & Charts",
              class: "breadcrumb-item",
            },
            {
              href: "#",
              name: "Performance Analytics",
              class: "breadcrumb-item",
            },
          );
        } else if (currentUrl.includes("999")) {
          this.isVisible(3);
          this.breadcrumList.push(
            {
              href: "#",
              name: "Service Maintaince",
              class: "breadcrumb-item",
            },
            {
              href: "#",
              name: "Maintaince Log",
              class: "breadcrumb-item active",
            },
          );
        } else if (currentUrl.includes("cameraImages")) {
          this.isVisible(3);
          this.breadcrumList.push(
            {
              href: "#",
              name: "Site Details",
              class: "breadcrumb-item",
            },
            {
              href: "#",
              name: "Camera Images",
              class: "breadcrumb-item",
            },
          );
        } else if (currentUrl.includes("device_dashboard")) {
          this.isVisible(3);
          this.breadcrumList.push({
            href: "#",
            name: "Device",
            class: "breadcrumb-item",
          });
        } else if (currentUrl.includes("138")) {
          this.isVisible(3);
          this.breadcrumList.push(
            {
              href: "#",
              name: "Manage",
              class: "breadcrumb-item",
            },
            {
              href: "#",
              name: "Application Audit Log",
              class: "breadcrumb-item",
            },
          );
        } else if (currentUrl.includes("142")) {
          this.isVisible(3);
          this.breadcrumList.push(
            {
              href: "#",
              name: "Reports & Charts",
              class: "breadcrumb-item",
            },
            {
              href: "#",
              name: "Advanced Custom Report",
              class: "breadcrumb-item",
            },
          );
        } else if (currentUrl.includes("153")) {
          this.isVisible(3);
          this.breadcrumList.push(
            {
              href: "#",
              name: "Analytics & Charts",
              class: "breadcrumb-item",
            },
            {
              href: "#",
              name: "Site / Device Health View",
              class: "breadcrumb-item",
            },
          );
        } else if (currentUrl.includes("222")) {
          this.isVisible(3);
          this.breadcrumList.push(
            {
              href: "#",
              name: "Manage",
              class: "breadcrumb-item",
            },
            {
              href: "#",
              name: "Fuel Dashboard",
              class: "breadcrumb-item",
            },
          );
        }

        this.sendDataToModule(currentUrl);
      }
    });
  }

  sendDataToModule(currentUrl) {
    const data = { currentUrl: currentUrl };
    this.sharedDataService.setData(data);
  }
  ngAfterViewInit(): void {
    this.showMenu("header-toggle", "navbar");
  }
  showMenu(headerToggle: string, navbarId: string): void {
    const toggleBtn = document.getElementById(headerToggle);
    const nav = document.getElementById(navbarId);
    if (toggleBtn && nav) {
      toggleBtn.addEventListener("click", () => {
        nav.classList.toggle("show-menu");
        toggleBtn.classList.toggle("fa-times");
      });
      const navItems = nav.querySelectorAll("a");
      navItems.forEach((item) => {
        item.addEventListener("click", () => {
          nav.classList.remove("show-menu");
          toggleBtn.classList.remove("fa-times");
        });
      });
      document.addEventListener("click", (event) => {
        if (
          !nav.contains(event.target as Node) &&
          !toggleBtn.contains(event.target as Node)
        ) {
          nav.classList.remove("show-menu");
          toggleBtn.classList.remove("fa-times");
        }
      });
    }
  }
  @HostListener("document:click", ["$event"])
  onDocumentClick(event: Event): void {
    const toggleBtn = document.getElementById("header-toggle");
    if (toggleBtn && toggleBtn.contains(event.target as Node)) {
      event.stopPropagation();
    }
  }

  width;
  screenSize;
  updateWidth(): void {
    this.width = window.innerWidth;
    this.screenSize = this.getSizeLabel(this.width);
  }

  updateGMTTimeWithOffset(offsetInSeconds: number) {
    const gmtTime = new Date();
    const adjustedTime = new Date(gmtTime.getTime() + offsetInSeconds * 1000);
    this.currentCustomerTime = this.formatDate(adjustedTime);
  }

  formatDate(date: Date): string {
    const day = String(date.getUTCDate()).padStart(2, "0");
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[date.getUTCMonth()];
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    const seconds = String(date.getUTCSeconds()).padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }
  getSizeLabel(width) {
    if (width >= 1200) {
      return "xl";
    } else if (width >= 992) {
      return "lg";
    } else if (width >= 768) {
      return "md";
    } else if (width >= 576) {
      return "sm";
    } else {
      return "xs";
    }
  }
  isVisible(linkNumber) {
    this.linkNu = linkNumber;
    sessionStorage.setItem("previousUrl", this.linkNu);
    if (linkNumber == "1") {
      this.barVisible1 = true;
      this.barVisible2 = false;
      this.barVisible3 = false;
      this.barVisible4 = false;
      this.barVisible5 = false;
    } else if (linkNumber == "2") {
      this.barVisible1 = false;
      this.barVisible2 = true;
      this.barVisible3 = false;
      this.barVisible4 = false;
      this.barVisible5 = false;
    } else if (linkNumber == "3") {
      this.barVisible1 = false;
      this.barVisible2 = false;
      this.barVisible3 = true;
      this.barVisible4 = false;
      this.barVisible5 = false;
    } else if (linkNumber == "4") {
      this.barVisible1 = false;
      this.barVisible2 = false;
      this.barVisible3 = false;
      this.barVisible4 = true;
      this.barVisible5 = false;
    } else if (linkNumber == "5") {
      this.barVisible1 = false;
      this.barVisible2 = false;
      this.barVisible3 = false;
      this.barVisible4 = false;
      this.barVisible5 = true;
    }
  }
  onMouseLeft() {
    this.barVisible1 = false;
    this.barVisible2 = false;
    this.barVisible3 = false;
    this.barVisible4 = false;
    this.barVisible5 = false;
  }

  logout() {
    const reqEntity = {
      Token: this.loginToken,
    };

    this.httpC
      .post(this.urlAuthentication.loginUrl + this.apiUrl.logoutUrl, {})
      .subscribe((response) => {
        window.open("#/login", "_self");
        localStorage.removeItem("invMonitoring");
        sessionStorage.clear();
        if (this.urlAuthentication.isAzureLogin) {
        }
      });

    localStorage.removeItem("invMonitoring");
    sessionStorage.clear();
  }
  selectedlink(link) {
    if (link.includes("#/")) {
      window.open(link, "_self");
    }
  }
  checkingSiteDetails(d) {
    if (d == "Site Details") {
      if (localStorage.getItem("siteDetailsOptions")) {
        let getSiteDetailsSiteID = localStorage.getItem("siteDetailsOptsions");
        const siteDetailsLink = "#/siteDetails";
        const str = '{"siteID":"' + getSiteDetailsSiteID + '"}';
        const encr = window.btoa(str);
        window.open(siteDetailsLink + "?e=" + encr, "_self");
      } else {
      }
    } else {
    }
  }
  initMenu() {
    $("#menu ul").hide();
    $("#menu ul").children(".current").parent().show();

    $("#menu li a").click(function () {
      var checkElement = $(this).next();
      if (checkElement.is("ul") && checkElement.is(":visible")) {
        return false;
      }
      if (checkElement.is("ul") && !checkElement.is(":visible")) {
        $("#menu ul:visible").slideUp("normal");
        checkElement.slideDown("normal");
        return false;
      }
    });
  }

  setGlobalValues(resp) {
    for (let g = 0; g < resp.length - 1; g++) {
      if (JSON.parse(resp[g].ID) == "RP0103") {
        this.globals.energyReport = resp[g].ID;
      }
      if (JSON.parse(resp[g].ID) == "RP0101") {
        this.globals.analyticalReport = resp[g].ID;
      }
      if (JSON.parse(resp[g].ID) == "RP0102") {
        this.globals.controllerReport = resp[g].ID;
      }
      if (JSON.parse(resp[g].ID) == "RP0105") {
        this.globals.controllerReport = resp[g].ID;
      }
      if (JSON.parse(resp[g].ID) == 110) {
        this.globals.customReport = resp[g].ID;
      }
    }
  }

  MenuFilter(event: any) {
    const filter = event.target.value.toLowerCase();

    if (!filter) {
      this.navJSON = [...this.originalNavJSON];
      return;
    }

    this.navJSON = this.originalNavJSON
      .map((nav) => {
        const parentMatch = nav.NAME.toLowerCase().includes(filter);
        const filteredChildren = nav.ChildOne.filter((child) =>
          child.NAME.toLowerCase().includes(filter),
        );

        const showSubmenu = parentMatch || filteredChildren.length > 0;

        return {
          ...nav,
          ChildOne: parentMatch ? nav.ChildOne : filteredChildren,
          showSubmenu: showSubmenu,
        };
      })
      .filter((nav) => nav.showSubmenu);
  }

  toggleMenu() {
    this.menuVisible = !this.menuVisible;
    if (!this.menuVisible) {
      this.resetSubmenuVisibility();
      this.activeMenuId = null;
    }
  }

  hideMenu() {
    this.menuVisible = false;
    this.resetSubmenuVisibility();
    this.resetActiveItems();
  }

  resetSubmenuVisibility() {
    this.navJSON.forEach((nav) => {
      nav.showSubmenu = false;
    });
  }

  resetActiveItems() {
    this.activeMenuId = null;
    this.activeSubMenuId = null;
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: any): void {
    this.updateWidth();
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isMobile = window.innerWidth <= 1024;
  }

  clickHandler(navlistID: string) {
    if (this.isMobile) {
      const submenu = this.navJSON.find((submenu) => submenu.ID === navlistID);
      if (submenu) {
        submenu.showSubmenu = !submenu.showSubmenu;
      }
    }

    this.activeMenuId = navlistID;
    this.activeSubMenuId = null;
    this.hideMenu();
  }

  onMouseOver(menuId: string) {
    if (!this.isMobile) {
      this.navJSON.forEach((menu) => {
        if (menu.URL === menuId) {
          menu.showSubmenu = true;
        }
      });
    }
  }

  onMouseLeave(menuId: string) {
    if (!this.isMobile) {
      this.navJSON.forEach((menu) => {
        if (menu.URL === menuId) {
          menu.showSubmenu = false;
        }
      });
    }
  }

  subMenuClickHandler(subMenuId: string) {
    this.activeSubMenuId = subMenuId;
    this.hideMenu();
  }

  formatJson(array) {
    array.sort((a, b) => {
      const rootA = a.rootID ?? -1;
      const rootB = b.rootID ?? -1;
      return rootA - rootB;
    });
    const map = {};
    for (const obj of array) {
      const id = obj.ID;
      const rootId = obj.RootID || "-";
      if (!map[id]) {
        map[id] = { ...obj, ChildOne: [] };
      } else {
        map[id] = { ...map[id], ...obj };
      }
      if (!map[rootId]) {
        map[rootId] = { ChildOne: [] };
      }
      map[rootId].ChildOne.push(map[id]);
    }
    // return map["-"]?.ChildOne || [];
    return map[0]?.ChildOne || [];
  }

  MenuShowHide(getClass) {
    if (getClass.length != 0) {
      $(".a" + getClass).removeClass("submenu");
    }
  }

  subMenuShowHide(data) {
    if (this.navJSON.length > 0) {
      this.navJSON.forEach((element) => {
        element.ChildOne.forEach((childOne) => {
          if (data.path == childOne.path) {
            if (childOne.length > 0) {
              if (childOne.ChildTwo.length == 0) {
                $("#" + data.path).removeClass("sub-submenu");
                $("#addRemoveArrow").removeClass("arrow");
              }
            }
          }
        });
      });
    }
  }

  private onClickOutside(event: MouseEvent) {
    const nav = document.getElementById("navbar");
    const toggleBtn = document.getElementById("headerToggle");

    if (
      nav &&
      toggleBtn &&
      !nav.contains(event.target as Node) &&
      !toggleBtn.contains(event.target as Node)
    ) {
      this.menuVisible = false;
      this.resetSubmenuVisibility();
      this.activeMenuId = null;
    }
  }

  ngOnInit() {
    this.updateGMTTimeWithOffset(this.accTimeZone);
    setInterval(() => {
      this.updateGMTTimeWithOffset(this.accTimeZone);
    }, 1000);

    this.clickListener = this.onClickOutside.bind(this);
    document.addEventListener("click", this.clickListener);
    this.checkScreenSize();
    this.updateWidth();

    window.addEventListener("storage", (event) => {
      if (event.storageArea == localStorage) {
        let logInfo = localStorage.getItem("invMonitoring");

        if (!logInfo) {
          const reqEntity = {
            Token: this.loginToken,
          };

          this.httpC
            .post(
              this.urlAuthentication.loginUrl + this.apiUrl.logoutUrl,
              {},
            )
            .subscribe((response) => {
              localStorage.removeItem("invMonitoring");
              sessionStorage.clear();
            });
          this.router.navigate(["/login"]);
        }
      }
    });
    let menuReq = { fmID: 0, widgets: "2" };
    this.http
      .post(
        this.urlAuthentication.genericApiUrl + this.apiUrl.getMenuUrl,
        menuReq,
      )
      .subscribe((res) => {
        const resp = res.response;
        let mainNavJson = this.formatJson(resp);
        this.navJSON = mainNavJson;
        this.originalNavJSON = [...this.navJSON];

        setTimeout(() => {
          this.setGlobalValues(resp);
          $(".menuId").removeAttr("href");
        }, 1000);
      });
    this.initMenu();
    $("#wrapper").toggleClass("toggled-2");
    $("#menu ul").hide();
  }

  openBackDropCustomClass(content) {
    this.modalService.open(content, { backdropClass: "light-blue-backdrop" });
  }
  openLg(content) {
    this.modalService.open(content, { size: "lg" });
  }
  openScrollableContent(longContent) {
    this.selectedVerifyPass = "";
    this.modalService.open(longContent);
  }
  setMessage(message, messageType) {
    if (message != "" && messageType != "") {
      this.arr_AlertMsg = [];
      this.arr_AlertMsg.push({
        type: messageType,
        message: message,
      });
    } else {
      this.arr_AlertMsg = [];
    }
  }
  close() {
    if (this.arr_AlertMsg.length > 0) {
      this.arr_AlertMsg.splice(this.arr_AlertMsg.indexOf(alert), 1);
    }
  }
  submitPassword() {
    this.arr_AlertMsg = [];
    let PostJson = {
      UserName: "",
      EmailId: "",
      OldPassword: this.passVal,
      NewPassword: this.selectedVerifyPass,
      NewConfirmPassword: this.targetVal,
    };
    this.http
      .post(
        this.urlAuthentication.itocUrl + this.apiUrl.sublitChangePasswordUrl,
        PostJson,
      )
      .subscribe((res) => {
        let getImgResp = JSON.stringify(res.body);
        let resp = JSON.parse(getImgResp);
        if (resp == "Password changed sucessfully") {
          this.setMessage(resp, "success");
          this.modalService.dismissAll();
          window.open("#/login", "_self");
        }
      });
  }
  openUserSetting() {
    window.open("#/userSetting", "_self");
  }

  closeModel() {
    this.selectedVerifyPass = "";
    this.modalService.dismissAll();
  }

  gotoPowerBI() {
    let powerBiUrl =
      "https://app.powerbi.com/links/2yuU1SJhhq?ctid=f8809024-638d-4570-9652-cb9c094a5faa&amp;pbi_source=linkShare";
    window.open(powerBiUrl, "_blank");
  }
  openTab(link) {
    if (link != "") {
      window.open("#/" + link, "_blank");
    }
  }
}
